/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Ui_Charts_Rest_RemainingInputs */

const en_us2_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rest: ${i?.time} left`)
};

const pt_br2_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descanso: ${i?.time} restantes`)
};

const es_419_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descanso: quedan ${i?.time}`)
};

const pt_pt2_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descanso: faltam ${i?.time}`)
};

const fr_fr2_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Repos : encore ${i?.time}`)
};

const de_de2_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pause: noch ${i?.time}`)
};

const it_it2_ui_charts_rest_remaining = /** @type {(inputs: Ui_Charts_Rest_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recupero: ${i?.time} rimanenti`)
};

/**
* | output |
* | --- |
* | "Rest: {time} left" |
*
* @param {Ui_Charts_Rest_RemainingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_rest_remaining = /** @type {((inputs: Ui_Charts_Rest_RemainingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Rest_RemainingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_rest_remaining(inputs)
	if (locale === "es-419") return es_419_ui_charts_rest_remaining(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_rest_remaining(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_rest_remaining(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_rest_remaining(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_rest_remaining(inputs)
	return en_us2_ui_charts_rest_remaining(inputs)
});
export { ui_charts_rest_remaining as "ui-charts.rest_remaining" }